import { render, staticRenderFns } from "./Dosage.vue?vue&type=template&id=6842ea2d&scoped=true"
import script from "./Dosage.vue?vue&type=script&lang=js"
export * from "./Dosage.vue?vue&type=script&lang=js"
import style0 from "./Dosage.vue?vue&type=style&index=0&id=6842ea2d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6842ea2d",
  null
  
)

export default component.exports